import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import SignedInvoiceExportModal from 'modules/expenses/pages/SignedInvoices/ExportModal'

const SignedInvoiceExportPage = () => {
  const { navigation } = useNavigation()

  const useOnClose = () => {
    const navigate = useNavigate()

    return () => {
      navigate(navigation.settings.expenses.signedInvoices.fullPath())
    }
  }

  return <SignedInvoiceExportModal onClose={useOnClose()} />
}

export default SignedInvoiceExportPage
